import React from "react";
import { Snackbar, Alert } from "@mui/material";

function CopyLinkSnackbar({
  open,
  onClose,
  message = "Link copied to clipboard",
  severity = "success",
  autoHideDuration = 2500,
}) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default CopyLinkSnackbar;